import { FC, memo, DragEvent, PropsWithChildren, ClipboardEventHandler } from "react";
import "./panel-body.scss";
import classNames from "classnames";

interface PanelBodyProps extends PropsWithChildren {
  onDrop?: (e: DragEvent<HTMLDivElement>) => void;
  onDragOver?: (e: DragEvent<HTMLDivElement>) => void;
  onDragLeave?: (e: DragEvent<HTMLDivElement>) => void;
  onClick?: () => void;
  onPaste?: ClipboardEventHandler<HTMLDivElement>;
  className?: string;
}

const PanelBodyComponent: FC<PanelBodyProps> = ({
  className = "",
  onDrop,
  children,
  ...restProps
}) => {
  return (
    <div className={classNames(`panel-body`, className)} onDrop={onDrop} {...restProps}>
      {children}
    </div>
  );
};

export const PanelBody = memo(PanelBodyComponent);
